webpackJsonp([19647912047630],{

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/a-town_logo_dark.7fbe5015.jpg";

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/at-movies_logo_circle_dark.22af32ca.jpg";

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SEO = __webpack_require__(21);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _pageModule = __webpack_require__(35);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	var _showsModule = __webpack_require__(303);
	
	var _showsModule2 = _interopRequireDefault(_showsModule);
	
	var _aTown_logo_dark = __webpack_require__(125);
	
	var _aTown_logo_dark2 = _interopRequireDefault(_aTown_logo_dark);
	
	var _atMovies_logo_circle_dark = __webpack_require__(624);
	
	var _atMovies_logo_circle_dark2 = _interopRequireDefault(_atMovies_logo_circle_dark);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        "div",
	        { className: _pageModule2.default.container },
	        _react2.default.createElement(_SEO2.default, { title: "Shows | A-Town FM" }),
	        _react2.default.createElement(
	            "h1",
	            null,
	            "Shows"
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _showsModule2.default.post },
	            _react2.default.createElement(
	                "div",
	                { className: _showsModule2.default.image },
	                _react2.default.createElement("img", { src: _atMovies_logo_circle_dark2.default, alt: "episode thumbnail" })
	            ),
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "h3",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "http://atownmovies.com/", className: _showsModule2.default.title },
	                        "A-Town at the Movies"
	                    )
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "From the creators of A-Town FM comes the movie podcast to end all movie podcasts."
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _showsModule2.default.post },
	            _react2.default.createElement(
	                "div",
	                { className: _showsModule2.default.image },
	                _react2.default.createElement("img", { src: _aTown_logo_dark2.default, alt: "episode thumbnail" })
	            ),
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "h3",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "http://atownfm.com/", className: _showsModule2.default.title },
	                        "A-Town FM"
	                    )
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Podcast where 2 Midwesterners discuss everything from movies, marketing, culture and a surprising amount on water towers."
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"post":"src-styles----shows-module---post---1tLC-","title":"src-styles----shows-module---title---2ckRW","image":"src-styles----shows-module---image---1cW3d"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-shows-js-5df540803dc5a359582b.js